import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=3b782443&"
import script from "./CertificatePage.vue?vue&type=script&lang=ts&"
export * from "./CertificatePage.vue?vue&type=script&lang=ts&"
import style0 from "./CertificatePage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CertificatePage.vue"
export default component.exports